import React from 'react';
import { Button } from 'components/Form';
import { ErrorFallbackStyles } from './Style'

/**
 * קומפוננטת Fallback (חלופה) שמוצגת אוטומטית במקרה של קריסה (Error) באחד מרכיבי הילד.
 * קומפוננטה זו משמשת בשילוב עם הספרייה `react-error-boundary`.
 * היא מונעת את "מסך המוות הלבן" של React ומציגה למשתמש הודעה ידידותית עם אפשרות לנסות לטעון מחדש.
 *
 * @param {Object} props - אובייקט הפרופס שמועבר אוטומטית על ידי ה-ErrorBoundary.
 * @param {Error} props.error - אובייקט השגיאה המקורי שגרם לקריסה (מכיל את הודעת השגיאה ב-`error.message`).
 * @param {Function} props.resetErrorBoundary - פונקציה שמאפשרת לאפס את מצב השגיאה ולנסות לרנדר את המסך מחדש (מופעלת בלחיצה על הכפתור).
 */
const ErrorFallback = ({ error, resetErrorBoundary }) => {
    return (
        <ErrorFallbackStyles>
            <h2>
                {" אופס, משהו השתבש... 😕"}
            </h2>
            {/* הצגת הודעת השגיאה הטכנית (יכול לעזור בדיבוג) */}
            <div className='error-text'>{error.message}</div>
            
            {/* כפתור שמאפשר למשתמש לנסות לאתחל את המסך מחדש */}
            <Button
                label="נסה שוב"
                color="thirdly"
                action={resetErrorBoundary}
            />
        </ErrorFallbackStyles>
    )
}

export default ErrorFallback;